GZ.rentCar = {
  _carsData: null,
  _currentCarId: null,
  _currentPricings: null,
  _swiperInstance: null,
  _currentSwiperSlideCount:0,

  init: function(){
    if(typeof _carsData !== "undefined" && _carsData !== undefined){
      this._carsData = _carsData;
      console.log('this._carsData', this._carsData);
    }
    var currentCar = $("#rent-cars").find(".car.current");
    this._currentCarId = currentCar.attr('data-car-id');

    if($("body").hasClass("page-template-page-rentcar")){
      GZ.datePicker.init();

      this.setSwiper();

      var summary = $("#rentcar-summary");

      // cf7 add anchor tag around 'voorwaarden'
      var label = $("input[name='client_terms[]']").parent().find(".wpcf7-list-item-label"),
          newValue;
      if(label.length > 0){
        newValue = label.text().replace("voorwaarden", "<a target=\"_blank\" href=\"/voorwaarden/\">voorwaarden</a>");
        label.html(newValue);
      }

      this._translate3dSupport = GZ.funcs.Has3DSupport();
      this._currentPricings = currentCar.find(".pricings").val().split("|");

      // this.stickySummary(summary);

      this.setExtraOptions(summary);

      this._summary.rentFrom.html( GZ.datePicker.rentFrom[0]._flatpickr.formatDate(GZ.datePicker.rentFrom[0]._flatpickr.selectedDates[0], "l, j F Y  - H:i") );
      this._summary.rentTo.html( GZ.datePicker.rentTo[0]._flatpickr.formatDate(GZ.datePicker.rentTo[0]._flatpickr.selectedDates[0], "l, j F Y  - H:i") );

      this.setListeners();

    }
  },

  getCurrentCar: function() {
    return this._carsData[this._currentCarId];
  },

  _translate3dSupport: null,
  _summaryIsSticky: false,

  stickySummary: function(summary){
    var self = this,
        summaryOffset = (summary.offset().top - GZ.funcs.rem(2)),
        formHolder = $("#rent-car-formholder"),
        formHolderHeight = ((formHolder.offset().top + formHolder.outerHeight()) - summary.outerHeight());

    $(window).on("scroll touchmove", function(e){
      window.requestAnimationFrame( function(){
        if($(this).scrollTop() >= summaryOffset){
          if($(this).scrollTop() < formHolderHeight){
            if(!self._summaryIsSticky){
              self._summaryIsSticky = true;
            }
            if(self._translate3dSupport){
              summary.css("transform", "translate3d(0, "+ Math.round($(this).scrollTop() - summaryOffset)+"px, 0)");
            } else {
              summary.css("margin-top", Math.round($(this).scrollTop() - summaryOffset)+"px");
            }
          }
        } else {
          if(self._summaryIsSticky){
            self._summaryIsSticky = false;
            summary.removeClass("is-sticky");
            summary.removeAttr("style");
          }
        }
      });
    });
  },

  _summary: null,
  _form: null,

  setExtraOptions: function(summary){
    var self = this,
        cars = $("#rent-cars"),
        currentCar = cars.find(".current"),
        statusbar = $("#rent-car-status-bar"),
        form = $("#your-rent");

    this._summary = {
      title: summary.find(".car-title"),
      image: summary.find(".car-image img"),
      characteristics: summary.find(".car-rent-characteristics p"),
      extraOptions: summary.find(".car-rent-extra-options .table"),
      rentFrom: summary.find("#from-period .value"),
      rentTo: summary.find("#to-period .value"),
      price: summary.find(".car-rent-subtotal .value"),
    };

    this._statusbar = {
      price: statusbar.find(".rent-price__value")
    }

    this._form = {
      chosenCar: $("#rent-car-formholder").find('#client-chosen-car'),
      chosenCarID: $("#rent-car-formholder").find('#client-chosen-car-id')
    };

    var carID = currentCar.attr('data-car-id');
    if(this._carsData[carID] !== undefined){
      cars.find(".car").removeClass("current");
      this._currentPricings = this._carsData[carID].pricings;
      this.setCurrentCarDetails(currentCar, this._carsData[carID], form);
    }

    cars.on("click", ".car", function(){
      var carID = $(this).attr('data-car-id');
      if(self._carsData[carID] !== undefined){
        cars.find(".car").removeClass("current");
        self._currentPricings = self._carsData[carID].pricings;
        self.setCurrentCarDetails($(this), self._carsData[carID], form);
      }
    });

    cars.on("click", ".specs", function(){
      $("html, body").animate({
        scrollTop: form.offset().top
      }, 250);
    });
  },

  setCurrentCarDetails: function(currentCar, carData, form){
    console.log('currentCar', currentCar);
    console.log('carData', carData);
    currentCar.addClass("current");

    this._currentCarId = currentCar.attr('data-car-id');

    $("#hidden-extra-options").val('');
    currentCar.parent().find(".car .actions .selected").text("Kies auto");
    currentCar.find(".actions .selected").text("Geselecteerd");

    // generate html objects
    var extraOptions = carData.extra_options;
    form.find("#client_extra_options")[0].innerHTML = "";
    form.find("#client_extra_options")[0].appendChild(this.generateOptions(extraOptions, carData.deposit));

    console.log('carData...', carData);
    this._form.chosenCar.val(carData.title);
    this._form.chosenCarID.val(carData.id);

    this._summary.characteristics.text(carData.specifications.join(', '));

    this._summary.title.text(carData.title);
    this._summary.image.attr("src", carData.thumb);

    this._summary.extraOptions.html('');

    var formattedPrice = (~carData.pricings[0].indexOf('.')) ? parseFloat(carData.pricings[0]).toFixed(2).replace(".", ",") : carData.pricings[0];

    this._statusbar.price.text(formattedPrice);

    GZ.datePicker.calculatePrice();
  },

  generateOptions: function(extraOptions, deposit){
    // item elements
    var label, input, optionName, optionPrice;

    var fragment = document.createDocumentFragment();

    if (deposit.active) {
      var optionTitle = "Verlaging eigen risico (van € "+ deposit.default +" naar € "+ deposit.discount +" / prijs per dag)";
      var optionTitleSanitized = optionTitle.toLowerCase();
          optionTitleSanitized = optionTitleSanitized.replace(' ', '-');

      optionPrice = document.createElement("span");
      optionPrice.innerHTML = "&euro; 5";
      optionPrice.className = "option-price";
      optionPrice.setAttribute('data-price-per-day', true);

      optionName = document.createElement("span");
      optionName.textContent = optionTitle;
      optionName.className = "option-name";

      input = document.createElement("input");
      input.value = optionTitle;
      input.type = "checkbox";
      input.name = "extra_options[]";
      input.id = optionTitleSanitized;
      input.setAttribute("data-discount-toggle", true);

      label = document.createElement("label");
      label.setAttribute("for", optionTitleSanitized);
      label.appendChild(input);
      label.appendChild(optionName);
      label.appendChild(optionPrice);

      fragment.appendChild(label);
    }

    for (var i = 0; i < extraOptions.length; i++) {
      optionPrice = document.createElement("span");
      optionPrice.innerHTML = "&euro; " + extraOptions[i].price;
      optionPrice.className = "option-price";
      optionPrice.setAttribute('data-price-per-day', extraOptions[i].per_day);

      optionName = document.createElement("span");
      optionName.textContent = extraOptions[i].name;
      optionName.className = "option-name";

      input = document.createElement("input");
      input.value = extraOptions[i].name;
      input.type = "checkbox";
      input.name = "extra_options[]";
      input.id = extraOptions[i].sanitized;

      label = document.createElement("label");
      label.setAttribute("for", extraOptions[i].sanitized);
      label.appendChild(input);
      label.appendChild(optionName);
      label.appendChild(optionPrice);

      fragment.appendChild(label);
    }

    return fragment;
  },

  setListeners: function(){
    var self = this;
    this.clientExtraOptions();
    this.statusBar();

    if($('body').hasClass('page-template-page-rentcar')) {
      document.addEventListener( 'wpcf7mailsent', function( event ) {
        window.location = window.location.hostname + '/bedankt';
      }, false );
    }
  },

  clientExtraOptions: function(){
    var self = this;
    var extraOptionsInput = $("#hidden-extra-options");
    $("#rent-car-formholder").on('change', "#client_extra_options input" , function(e){
      console.log('self._summary', self._summary);
      self._summary.extraOptions.html(self.generateExtraOptions());
      extraOptionsInput.val(self.generateTableRows());
      console.log('changed', $(this).val());

      GZ.datePicker.calculatePrice();
    });
  },

  _statusBarOpen: false,
  _statusClickable: true,

  statusBar: function() {
    var self = this;
    var $statusBarHolder = $("#rent-car-status-bar");
    // todo handle statusbar click listeners
    $statusBarHolder.on('click', function() {
      if (!self._statusClickable) return;
      self._statusClickable = false;
      if (self._statusBarOpen) {
        $statusBarHolder.removeClass('status-bar--open status-bar--opening');
        window.setTimeout(function() {
          self._statusBarOpen = false;
          self._statusClickable = true;
        }, 200);
      } else {
        $statusBarHolder.addClass('status-bar--opening');
        window.setTimeout(function() {
          $statusBarHolder.addClass('status-bar--open');
          self._statusBarOpen = true;
          self._statusClickable = true;
        }, 200);
      }

    });
  },

  generateExtraOptions: function(){
    var htmlObjs = [];
    var label, price;

    var checkedValues = $("#rent-car-formholder").find("#client_extra_options input:checked");
    if(checkedValues.length === 0) return '';
    htmlObjs.push([
      '<table class="car-rent-extra-options">',
      '<tbody>',
      '<colgroup>',
      '<col width="65%">',
      '<col width="35%">',
      '</colgroup>',
      '<tr>',
        '<th class="pricing-label">Extra opties</th>',
        '<th class="price">Prijs</th>',
      '</tr>'
    ].join(''));

    checkedValues.each( function(){
      label = $(this).val();
      perDay = ($(this).parent().find('.option-price').attr('data-price-per-day') == 'true');
      price = $(this).parent().find('.option-price').text();
      htmlObjs.push([
        '<tr class="car-rent-extra-options">',
          '<td class="label">'+ label + (perDay ? ' <strong>(per dag)</strong>' : '') +'</td>',
          '<td class="price">'+ price +'</td>',
        '</tr>'
      ].join(''));
    });

    htmlObjs.push([
        '</tbody>',
      '</table>'
    ].join(''));

    return htmlObjs.join('');
  },

  generateTableRows: function(){
    var value = '';
    var label, price, perDay;
    $("#rent-car-formholder").find("#client_extra_options input:checked").each( function(){
      label = $(this).val();
      if(value === ''){
        value = label;
      } else {
        value += '|' + label;
      }
    });

    return value;
  },

  setSwiper: function() {
    var windowWidth = $(window).outerWidth();
    var slidesCount = 4;
    if(windowWidth < 1024 && windowWidth > 850 ){
      slidesCount = 3;
    } else if(windowWidth <= 850 && windowWidth > 550){
      slidesCount = 2;
    } else if(windowWidth <= 550){
      slidesCount = 1;
    } else {
      slidesCount = 4;
    }


    this._currentSwiperSlideCount = slidesCount;

    this._swiperInstance = new Swiper('#rent-cars', {
        pagination: '.swiper-pagination',
        slidesPerView: slidesCount,
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            850: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            550: {
                slidesPerView: 1,
                spaceBetween: 30
            }
        }
    });

    var highlightedCar = $("#rent-cars .highlighted");
    if(highlightedCar.length > 0){
      this._swiperInstance.slideTo(highlightedCar.index(),300,false);
    }
  }
};
